import { useState } from "react";
import { SwipeableDrawer, IconButton, TextField, Divider, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import ButtonLoading from "../../../components/ButtonLoading";
import SubTitle from "../../../components/SubTitle";

import DialogConfirm from "../../../components/DialogConfirm";
import { createSuite, deleteSuite, updateSuite } from "../../../api/projects";
import { USER_DATA } from "../../../utils/constants";

import { CSSProperties } from "react";
import { SuiteTypes } from "../../../interfaces/SuiteTypes";
import { ProjectsTypes } from "../../../interfaces/ProjectsTypes";
import Row from "../../../components/layout/Row";
import Input from "../../../components/Input";
import { colors } from "../../../assets/colors";
import { createHistory } from "../../../api/history";
import { ActionTypeEnum, HistoryTypes } from "../../../interfaces/HistoryTypes";
import { mountHistory } from "../../../utils/history";
import { reload } from "firebase/auth";

const drawerWidth = 600;

interface Props {
  selectedSuite?: SuiteTypes;
  currentProject: ProjectsTypes;
  close?: (reload?: boolean) => void;
  id?: string
}

function DrawerSuite(props: Props) {

  const [open, setOpen] = useState(true);
  const [title, setTitle] = useState(props.selectedSuite ? props.selectedSuite["title"] : "");
  const [id, setId] = useState(props.selectedSuite ? props.selectedSuite["id"] : null);

  const [projectTitle, setProjectTitle] = useState(`${props.currentProject.project_id} - ${props.currentProject.title}`);
  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(open);
    if (props.close) {
      props.close();
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setLoading(true);

    if (id) {
      updateSuite(id, title)
        .then(() => {
          toast.success("Suite atualizado com sucesso");
          createHistory(mountHistory(props.currentProject.project_id, ActionTypeEnum.UPDATE, "Suite: de " + (props.selectedSuite ? props.selectedSuite["title"] : "") + " para " + title))

          if (props.close) {
            props.close(true);
          }

        })
        .catch((e) => {
          console.log(e)
          toast.error("Ocorreu um problema, tente mais tarde!!!!");
        })
        .finally(() => {
          setLoading(false);
        });
    } else {

      const data = {
        title,
        id: new Date().getTime(),
        project_id: props.currentProject.project_id,
        test_cases: [],
        user_uuid: JSON.parse(localStorage.getItem(USER_DATA) || '{}').uid,
      };

      createSuite(data)
        .then(() => {
          toast.success("Suite adicionado com sucesso");
          createHistory(mountHistory(props.currentProject.project_id, ActionTypeEnum.CREATE, "Suite: " + title))
          if (props.close) {
            props.close(true);
          }

        })
        .catch((e) => {
          toast.error("Ocorreu um problema, tente mais tarde!!!!");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const deleteItem = (responseOk: boolean) => {
    setOpenDelete(false);
    if (!responseOk) {
      return;
    }

    setLoading(true);
    deleteSuite(props.selectedSuite as SuiteTypes)
      .then(() => {
        toast.success("Caso de Teste excluído com sucesso");
        createHistory(mountHistory(props.currentProject.project_id, ActionTypeEnum.DELETE, "Suite: " + title))
        if (props.close) {
          props.close(true);
        }
      })
      .catch((e) => {
        toast.error("Ocorreu um problema, tente mais tarde!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}
      sx={{
        zIndex: "1300",
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
    >
      <Row padding>
        <div style={styles.buttonClose}>
          <IconButton component="span" onClick={toggleDrawer(false)}>
            <CloseIcon />
          </IconButton>
        </div>
        <span style={styles.title}>
          {props.id ? "Atualizar Suite" : "Adicionar Suite"}
        </span>
      </Row>
      <Divider />

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div style={styles.box}>

          <SubTitle text={"Projeto"} />
          <span style={{ color: colors.gray }}>{projectTitle}</span>

          <Input
            title="Titulo"
            placeholder="Nome da suite"
            required
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <Box sx={styles.buttonsContainer}>
            {id ? (
              <ButtonLoading
                label="Excluir"
                onClick={() => setOpenDelete(true)}
                isDelete
              />
            ) : null}

            <ButtonLoading label="Salvar Suite" loading={loading} />
          </Box>
        </div>
      </form>

      {openDelete && (
        <DialogConfirm
          onResponse={deleteItem}
          entity="esse projeto"
        />
      )}

    </SwipeableDrawer>
  );
}

const styles: { [key: string]: CSSProperties } = {
  buttonClose: {
    background: "#C4C4C4",
    borderRadius: "6px",
    height: "32px",
    width: "32px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "10px",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    padding: "12px",
    alignItems: "center",
    justifyContent: "start",
  },
  box: {
    padding: "20px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  itemBox: {
    width: "100%",
    marginBottom: "20px",
  },
  title: {
    fontFamily: 'Poppins',
    fontWeight: '500',
    fontSize: '19px',
    lineHeight: '28px',
    letterSpacing: '0.4px',
    color: '#252733'
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'flex-end',
    gap: 2
  }
};

export default DrawerSuite;
